import { render, staticRenderFns } from "./TreeList.vue?vue&type=template&id=23b85634&scoped=true&"
import script from "./TreeList.vue?vue&type=script&lang=js&"
export * from "./TreeList.vue?vue&type=script&lang=js&"
import style0 from "./TreeList.vue?vue&type=style&index=0&id=23b85634&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./TreeList.vue?vue&type=style&index=1&id=23b85634&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b85634",
  null
  
)

export default component.exports